import { config } from 'config'
import { useTranslation } from 'react-i18next'
import { isPoland } from 'shared/utils'

export const useLandingUrls = () => {
  const { i18n } = useTranslation()

  const {
    LANDING_PAGE_REGULATIONS_URL_PL,
    LANDING_PAGE_FAQ_URL_PL,
    LANDING_PAGE_SUPPORT_URL_PL,
    LANDING_PAGE_PRIVACY_URL_PL,
    LANDING_PAGE_REGULATIONS_URL_EN,
    LANDING_PAGE_FAQ_URL_EN,
    LANDING_PAGE_SUPPORT_UR_EN,
    LANDING_PAGE_PRIVACY_URL_EN,
  } = config

  const urls = {
    LANDING_PAGE_REGULATIONS_URL: isPoland(i18n.language)
      ? LANDING_PAGE_REGULATIONS_URL_PL
      : LANDING_PAGE_REGULATIONS_URL_EN,
    LANDING_PAGE_FAQ_URL: isPoland(i18n.language)
      ? LANDING_PAGE_FAQ_URL_PL
      : LANDING_PAGE_FAQ_URL_EN,
    LANDING_PAGE_SUPPORT_URL: isPoland(i18n.language)
      ? LANDING_PAGE_SUPPORT_URL_PL
      : LANDING_PAGE_SUPPORT_UR_EN,
    LANDING_PAGE_PRIVACY_URL: isPoland(i18n.language)
      ? LANDING_PAGE_PRIVACY_URL_PL
      : LANDING_PAGE_PRIVACY_URL_EN,
  }

  return urls
}
